var map = {
	"./bfs/app/shared/collection-dropdown/collection-dropdown.component": [
		23959
	],
	"./custom/app/shared/collection-dropdown/collection-dropdown.component": [
		15733,
		"src_themes_custom_app_shared_collection-dropdown_collection-dropdown_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80882;
module.exports = webpackAsyncContext;